/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditEntryDetail } from '../../models/audit-entry-detail';

export interface AuditGet$Plain$Params {
  id: string;
}

export function auditGet$Plain(http: HttpClient, rootUrl: string, params: AuditGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditEntryDetail>> {
  const rb = new RequestBuilder(rootUrl, auditGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditEntryDetail>;
    })
  );
}

auditGet$Plain.PATH = '/api/v1/platform/audit/{id}';
